import React from 'react';

const ShippingPolicy = () => {
  return (
    <div className="p-6 bg-gray-50 rounded-lg shadow-lg">
      <h1 className="text-3xl font-bold text-center text-gray-800 mb-8">Shipping Policy</h1>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">1. General</h2>
        <p className="text-base text-gray-600 leading-relaxed">
          Subject to stock availability. We try to maintain accurate stock counts on our website but from time-to-time there may be a stock discrepancy, and we will not be able to fulfill all your items at the time of purchase. In this instance, we will fulfill the available products to you and contact you about whether you would prefer to await restocking of the backordered item or prefer a refund.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">2. Shipping Costs</h2>

        <h3 className="text-xl font-semibold text-gray-700 mb-2">2.1 Domestic Shipping</h3>
        <p className="text-base text-gray-600 leading-relaxed mb-4">
          Shipping costs are calculated during checkout based on weight, dimensions, and destination of the items in the order. Payment for shipping will be collected with the purchase. This price will be the final price for shipping cost to the customer.
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mb-2">2.2 International Shipping</h3>
        <p className="text-base text-gray-600 leading-relaxed">
          Shipping costs are calculated during checkout based on weight, dimensions, and destination of the items in the order. Payment for shipping will be collected with the purchase. This price will be the final price for shipping cost to the customer. Once the order is dispatched, there will be no cancellation of the order allowed. Additionally, the customer is liable to pay the custom duty charges levied by the government during the delivery of the order. In case the customer does not pay the custom duty charges, Luggaelegacy is not liable to refund the order amount to the customer.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">3. Delivery Terms</h2>

        <h3 className="text-xl font-semibold text-gray-700 mb-2">3.1 Transit Time Domestically</h3>
        <p className="text-base text-gray-600 leading-relaxed mb-4">
          In general, domestic shipments are in transit for 2 - 7 days, and for international shipments, they are in transit for 5-10 days.
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mb-2">3.2 Dispatch Time</h3>
        <p className="text-base text-gray-600 leading-relaxed mb-4">
          Orders are usually dispatched within 2 business days of payment. Our warehouse operates on Monday - Saturday during standard business hours, except on national holidays, at which time the warehouse will be closed. In these instances, we take steps to ensure shipment delays will be kept to a minimum.
        </p>


        <h3 className="text-xl font-semibold text-gray-700 mb-2">3.3 Items Out Of Stock</h3>
        <p className="text-base text-gray-600 leading-relaxed mb-4">
          If an item is out of stock, we will cancel and refund the out-of-stock items and dispatch the rest of the order.
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mb-2">3.4 Delivery Time Exceeded</h3>
        <p className="text-base text-gray-600 leading-relaxed">
          If delivery time has exceeded the forecasted time, please contact us so that we can conduct an investigation.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">6. Duties & Taxes</h2>
        <p className="text-base text-gray-600 leading-relaxed">
          Sales tax has already been applied to the price of the goods as displayed on the website.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">7. Cancellations</h2>
        <p className="text-base text-gray-600 leading-relaxed">
          If you change your mind before you have received your order, we are able to accept cancellations at any time before the order has been dispatched. If an order has already been dispatched, the order will not be canceled.
        </p>
      </section>

    </div>
  );
};

export default ShippingPolicy;
